const PROJECT_STATUSES = [
  { text: 'Draft', value: 'draft' },
  { text: 'Ready', value: 'ready' },
  { text: 'Published', value: 'published' },
  { text: 'Archived', value: 'archived' },
  { text: 'Deleted', value: 'deleted' },
];
export default PROJECT_STATUSES;



// WEBPACK FOOTER //
// ./src/constants/projectStatuses.js